export class AppPathConsts {
  static readonly MastersPrefix = 'masters';
  static readonly ExternalPrefix = 'externals';
  static readonly ServiceEntrySheetPrefix = 'ses';

  static readonly Places = 'places';
  static readonly PlacesCreate = this.Places + '/create';
  static readonly PlacesEdit = this.Places + '/edit/';

  static readonly RoleVendors = 'role-vendors';
  static readonly RoleVendorsEdit = this.RoleVendors + '/edit/';

  static readonly ExternalSystems = 'external-systems';
  static readonly ExternalSystemsCreate = this.ExternalSystems + '/create';
  static readonly ExternalSystemsEdit = this.ExternalSystems + '/edit/';

  static readonly Vendors = 'vendors';
  static readonly VendorsCreate = this.Vendors + '/create';
  static readonly VendorsEdit = this.Vendors + '/edit/';

  static readonly Services = 'services';
  static readonly ServicesCreate = this.Services + '/create';
  static readonly ServicesEdit = this.Services + '/edit/';

  static readonly Providers = 'providers';
  static readonly ProvidersCreate = this.Providers + '/create';
  static readonly ProvidersEdit = this.Providers + '/edit/';

  static readonly Actions = 'actions';
  static readonly ActionsEdit = this.Actions + '/edit/';

  static readonly UserProviders = 'user-providers';
  static readonly UserProvidersCreate = this.UserProviders + '/create';
  static readonly UserProvidersEdit = this.UserProviders + '/edit/';

  static readonly ServiceConfigurations = 'service-configurations';
  static readonly ServiceConfigurationsCreate = this.ServiceConfigurations + '/create';
  static readonly ServiceConfigurationsEdit = this.ServiceConfigurations + '/edit/';

  static readonly Periods = 'periods';
  static readonly PeriodsCreate = this.Periods + '/create';
  static readonly PeriodsEdit = this.Periods + '/edit/';

  static readonly ServiceEntrySheet = 'service-entry-sheets';
  static readonly ServiceEntrySheetGeneration = 'generation';
  static readonly ServiceEntrySheetOrderLines = '/order-lines/';
  static readonly ServiceEntrySheetOrderLinesPeriodParameter = 'periodId';
  static readonly ServiceEntrySheetOrderLinesProviderParameter = 'providerId';
  static readonly ServiceEntrySheetOrderLinesServiceParameter = 'purchaseOrderLine';
  static readonly ServiceEntrySheetOrderLinesParameters = `generation/order-lines/:${this.ServiceEntrySheetOrderLinesPeriodParameter}/:${this.ServiceEntrySheetOrderLinesProviderParameter}/:${this.ServiceEntrySheetOrderLinesServiceParameter}`;
  static readonly ServiceEntrySheetGenerationOrderLinesDetails = `order-lines/details/`;
  static readonly ServiceEntrySheetVisualizationDetails = `details/`;

  static readonly ServiceTypes = 'service-types';
  static readonly ServiceTypesCreate = this.ServiceTypes + '/create';
  static readonly ServiceTypesEdit = this.ServiceTypes + '/edit/';
  static readonly CreateOrderLineSimulator = 'create-order-line-simulator';

  static readonly IntegrationMonitor = 'integration-monitor';

  static readonly ProviderConfigurations = 'provider-configurations';
  static readonly ProviderConfigurationsCreate = this.ProviderConfigurations + '/create';
  static readonly ProviderConfigurationsEdit = this.ProviderConfigurations + '/edit/';
}
